/**
 * @module app.config.gpspoints
 */
class Controller {
  /**
   * @param {angularGettext.Catalog} gettextCatalog
   * @param {app.track.service} appTrackService
   * @param {!angular.$http} $http
   * @param apiUrl
   * @ngInject
   */
  constructor(gettextCatalog, appTrackService, $http, apiUrl) {
    /**
     * @type {number}
     * @export
     */
    this.gpsPoints;

    /**
     * @type {function(appx.GpsPointsChangeEvent)}
     * @export
     */
    this.onChange;

    this.appTrackService = appTrackService;

    /**
     * @private
     */
    this.http_ = $http;

    /**
     * @private
     */
    this.apiUrl_ = apiUrl;

    this.gettextCatalog = gettextCatalog;

    /**
     * @type {Array.<Object.<string, (number|string)>>}
     * @export
     */
    this.gpsPointsList = [
      {'value': 250, 'getLabel': () => gettextCatalog.getString('gps250')},
      {'value': 500, 'getLabel': () => gettextCatalog.getString('gps500')},
      {'value': 1000, 'getLabel': () => gettextCatalog.getString('gps1000')},
      {'value': null, 'getLabel': () => gettextCatalog.getString('gpsnull')},
    ];
  }

  /**
   * @export
   * @param {?number} gpsPoints
   * @return {function(): boolean}
   */
  isCheckedGetter(gpsPoints) {
    return () => gpsPoints === this.gpsPoints;
  }

  /**
   * @export
   * @param {number} gpsPoints
   */
  setGpsPoints(gpsPoints) {
    this.gpsPoints = gpsPoints;
    this.onChange({gpsPoints});
    const track = this.appTrackService.selectedTrack;
    if (track && track.recorded) {
      this.http_.put(`${this.apiUrl_}5/recordedtracks/${track.id}`, {properties: {gpspoints: gpsPoints}}).then(() => {
        track.properties.gpspoints = gpsPoints;
      }).catch(() => {
        bootbox.alert({message: this.gettextCatalog.getString('Error when saving track config')});
      });
    }
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'gpsPoints': '<',
    'labelText': '@',
    'onChange': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/config/gpspoints/partial.html'
};

export default angular.module('appConfigGpsPointsComponent', [])
  .component('appConfigGpsPoints', component);
